import { useState, useEffect } from 'react';

// Custom hook to animate a number from 0 to 'end'
const useCountUp = (end, duration = 1000) => {
  const [count, setCount] = useState(0);
  const start = 0;
  const numericEnd = Number(end); // Ensure the end value is treated as a number

  useEffect(() => {
    if (numericEnd === 0) {
      setCount(0);
      return;
    }

    let startTime;
    
    // The step function updates the count over time
    const step = (timestamp) => {
      if (!startTime) startTime = timestamp;
      const progress = timestamp - startTime;
      const percentage = Math.min(progress / duration, 1); // Clamp between 0 and 1

      // Calculate the current value (eased calculation)
      const currentValue = Math.floor(percentage * (numericEnd - start) + start);
      setCount(currentValue);

      if (percentage < 1) {
        window.requestAnimationFrame(step);
      }
    };

    // Start the animation
    window.requestAnimationFrame(step);

    // Cleanup function
    return () => {
        startTime = null;
    };
  }, [numericEnd, duration]);

  // Format the number back to a string, using locale for thousands separation
  return count.toLocaleString();
};

export default useCountUp;